import { DynamischeAbwesenheitArt } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/dynamischeAbwesenheitstypen';
import { Mitarbeiter_DynamischeAbwesenheitsArt } from '@/gql/graphql';

export function mapDynamischeAbwesenheitArt(
  art: DynamischeAbwesenheitArt,
): Mitarbeiter_DynamischeAbwesenheitsArt {
  switch (art) {
    case 'tagesschnitt':
      return Mitarbeiter_DynamischeAbwesenheitsArt.Tagesdurchschnitt;

    case 'wochenschnitt':
      return Mitarbeiter_DynamischeAbwesenheitsArt.Wochendurchschnitt;
    case 'drei_monatsschnitt':
      return Mitarbeiter_DynamischeAbwesenheitsArt.DreiMonatsdurchschnitt;

    case '12_monatsschnitt':
      return Mitarbeiter_DynamischeAbwesenheitsArt.ZwoelfMonatsdurchschnitt;
    default:
      art satisfies never;
      throw new Error(`Unexpected value of DynamischeAbwesenheitArt ${art}`);
  }
}
